import { render, staticRenderFns } from "./PracticesRequiringAction.vue?vue&type=template&id=4731a964&"
import script from "./PracticesRequiringAction.vue?vue&type=script&lang=js&"
export * from "./PracticesRequiringAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports